import { AccessibilityState } from '../types/accessibility.types';

export const applyAccessibilitySettings = (
  state: AccessibilityState
): void => {
  const root = document.documentElement;

  root.style.setProperty('--app-font-scale', `${state.fontScale}`);

  root.dataset.theme = state.theme;

  root.classList.toggle('underline-links', state.underlineLinks);

  root.classList.toggle('highlight-links', state.highlightLinks);

  root.classList.toggle('readable-font', state.readableFont);

  root.classList.toggle('reduce-motion', state.reduceMotion);

  root.classList.toggle('text-spacing', state.textSpacing);

  root.classList.toggle('large-cursor', state.largeCursor);

  root.classList.toggle('reading-guide-enabled', state.readingGuide);
};